<template>
  <vs-divider class="operation-divider m-0" :color="color" />
</template>

<script>
import ColorMixin from "@/mixins/ColorMixin.js";
const { AISEA_COLOR } = ColorMixin.data();

export default {
  name: "OperationDivider",
  props: {
    color: {
      type: String,
      default: AISEA_COLOR.LIGHT_GRAY,
    },
  },
};
</script>
